var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$route.meta.public === true)?_c('Public'):_vm._e(),(this.$route.meta.public === false && _vm.tokenValid)?_c('Secure',{on:{"logout":_vm.logout}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }